import React, {useEffect, useState} from "react";
import FCMNotificationCard from "./FCMNotificationCard";
import {onFCMMessage, requestFCMPermissionAndToken} from "../firebase/fcm";
import secureLocalStorage from "react-secure-storage";
import {REACT_APP_FCM_URL} from "../env";
import {useDispatch} from "react-redux";
import {refreshDatumOrders, setHazard} from "../actions";
import {useHistory} from 'react-router-dom';
import NotificationPermissionManager from './NotificationPermissionManager';

export default function FCMListener() {
  const [notification, setNotification] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Only auto-request token if permission already granted
    if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
      requestFCMPermissionAndToken()?.then(token => {
        if (token) {
          // console.log(token);
          return secureLocalStorage.setItem('fcmToken', token);
        } else {
          console.warn("No FCM token received");
        }
      }).catch(error => {
        console.error(error)
      });
    }

    // Listen to messages from the Service Worker (background notification clicks)
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        const data = event?.data;
        if (data?.type === 'HAZARD_NOTIFICATION' && data?.payload) {
          const { title, body, data: extra } = data.payload;
          dispatch(setHazard({ title, body, data: extra }));
          history.push('/hazard');
        }
      });
    }

    onFCMMessage(payload => {
      // Native browser notification
      const title = payload.notification?.title || payload.data?.title || 'Notification';
      const options = {
        body: payload.notification?.body || payload.data?.body || '',
        icon: payload.notification?.image || payload.data?.image || '/logo192.png',
        data: payload.data
      };
      if (Notification.permission === 'granted') {
        const n = new Notification(title, options);
        n.onclick = (event) => {
          let url;
          if (payload.data?.page && payload.data?.id) {
            url = `https://staging-cu.reposenergy.com/${payload.data.page === 'asset' ? 
                'allDatumOrders/New?asset_id=' : payload.data.page === 'order' ? 'myOrders' : payload.data.page}${payload.data.id}`;
          } else if (payload.data?.deep_link) {
            url = payload.data.deep_link;
          }
          if (url) {
            window.open(url, '_blank');
          }
        };
      }
      // Custom React notification card
      let deepLink = payload.notification?.image;
      if (payload.data && payload.data.page && payload.data.id) {
        deepLink = `${REACT_APP_FCM_URL}${payload.data.page === 'asset' ?
            'allDatumOrders/New?asset_id=' : payload.data.page === 'order' ? 'myOrders' : payload.data.page}${payload.data.id}`;
      } else if (payload.data && payload.data.deep_link) {
        deepLink = payload.data.deep_link;
      }
      setNotification({
        title: payload.notification?.title || payload.data?.title || payload.data?.key1,
        body: payload.notification?.body || payload.data?.body || payload.data?.key2,
        image: payload.notification?.image || payload.data?.image,
        deepLink
      });
      
      // Dispatch the refresh action if notification is related to Datum
      if (payload.data?.page === 'asset' || 
          (payload.notification?.title && payload.notification.title.toLowerCase().includes('datum')) ||
          (payload.data?.title && payload.data.title.toLowerCase().includes('datum'))) {
        // Dispatch Redux action to refresh DatumOrders
        dispatch(refreshDatumOrders());
      }

      // Navigate to Hazard page if hazardous alert
      const nTitle = (payload.notification?.title || payload.data?.title || '').trim();
      if (nTitle === 'Hazardous!!!') {
        const body = payload.notification?.body || payload.data?.body || '';
        const extra = payload.data || null;
        dispatch(setHazard({ title: nTitle, body, data: extra }));
        history.push('/hazard');
      }
      
      // Auto-dismiss after 8s
      setTimeout(() => setNotification(null), 8000);
    });
  }, [dispatch, history]);

  return (
    <>
      {/* Permission manager shown when notifications are not granted */}
      <NotificationPermissionManager
        onGranted={(token) => {
          try { secureLocalStorage.setItem('fcmToken', token); } catch {}
        }}
      />
      {notification ? (
        <div style={{ position: 'fixed', top: 24, right: 24, zIndex: 9999 }}>
          <FCMNotificationCard
            title={notification.title}
            body={notification.body}
            image={notification.image}
            deepLink={notification.deepLink}
            onClose={() => setNotification(null)}
          />
        </div>
      ) : null}
    </>
  );
}
